import React, { Component } from "react";
import ReactTable from "react-table";
import "react-table/react-table.css";
import requester from "../../lib/requester";
import { Loader } from "react-overlay-loader";
import "react-overlay-loader/styles.css";
import moment from "moment";
import _ from "lodash";
import ReactExport from "react-export-excel";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "react-datepicker/dist/react-datepicker-cssmodules.css";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

class Summary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      startDate: new Date(),
      endDate: new Date(),
      // startDate: "",
      // endDate: "",
      dataTable: [],
      dataTable: [],
      baseTable: [],
      search: "",
      user: JSON.parse(window.localStorage.getItem("is_user")),
      fromDate: "",
      toDate: "",
      setStatus: "ALL",
      submittedDateFrom: "",
      submittedDateTo: "",
      status: "",
      activeStatus: "",
      export: false,
      lovBranch: [],
      originOrgid: "",
      setBranch: "",
      lovPrincipal: [],
      setPrincipal: "",
    };
  }

  componentDidMount = () => {
    this.getBranch();
    this.getPrincipal();
  };

  renderTable = () => {
    const data = {
      columns: [
        {
          Header: "PROGRAM NO",
          accessor: "PROGRAM_NO",
          filterable: true,
        },
        {
          Header: "REF NO",
          accessor: "REFF_NO",
          filterable: true,
        },
        {
          Header: "PROGRAM TYPE",
          accessor: "PROGRAM_TYPE",
          filterable: true,
        },
        {
          Header: "PRINCIPAL",
          accessor: "PRINCIPAL",
          filterable: true,
        },
        {
          Header: "DESCRIPTION",
          accessor: "DESCRIPTION",
          filterable: true,
        },
        {
          Header: "SUBMITTED DATE",
          accessor: "SUBMITTED_DATE",
          filterable: true,
          Cell: (row) => (
            <span>
              <span>
                {row.value !== null && row.value !== "" && row.value !== "null"
                  ? moment(new Date(row.value)).format("DD-MMM-YYYY")
                  : ""}
              </span>
            </span>
          ),
        },
        {
          Header: "START DATE",
          accessor: "START_DATE",
          filterable: true,
          Cell: (row) => (
            <span>
              <span>
                {row.value !== null && row.value !== "" && row.value !== "null"
                  ? moment(new Date(row.value)).format("DD-MMM-YYYY")
                  : ""}
              </span>
            </span>
          ),
        },
        {
          Header: "END DATE",
          accessor: "START_DATE",
          filterable: true,
          Cell: (row) => (
            <span>
              <span>
                {row.value !== null && row.value !== "" && row.value !== "null"
                  ? moment(new Date(row.value)).format("DD-MMM-YYYY")
                  : ""}
              </span>
            </span>
          ),
        },
        {
          Header: "CLAIM EXP DATE",
          accessor: "CLAIM_EXP_DATE",
          filterable: true,
          Cell: (row) => (
            <span>
              <span>
                {row.value !== null && row.value !== "" && row.value !== "null"
                  ? moment(new Date(row.value)).format("DD-MMM-YYYY")
                  : ""}
              </span>
            </span>
          ),
        },
        {
          Header: "BUDGET",
          accessor: "BUDGET",
          filterable: true,
          // style: "text-align: right",
          Cell: (row) => (
            <div style={{ textAlign: "right" }}>
              <span>
                {row.value !== null && row.value !== "" && row.value !== "null"
                  ? row.value.toLocaleString("en-US", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })
                  : ""}
              </span>
            </div>
          ),
        },
        {
          Header: "AMT CLAIM SUBMIT",
          accessor: "AMT_CLAIM_SUBMIT",
          filterable: true,
          // style: "text-align: right",
          Cell: (row) => (
            <div style={{ textAlign: "right" }}>
              <span>
                {row.value !== null && row.value !== "" && row.value !== "null"
                  ? row.value.toLocaleString("en-US", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })
                  : ""}
              </span>
            </div>
          ),
        },
        {
          Header: "AMT CLAIM APPROVED",
          accessor: "AMT_CLAIM_APPROVED",
          filterable: true,
          // style: "text-align: right",
          Cell: (row) => (
            <div style={{ textAlign: "right" }}>
              <span>
                {row.value !== null && row.value !== "" && row.value !== "null"
                  ? row.value.toLocaleString("en-US", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })
                  : ""}
              </span>
            </div>
          ),
        },
        {
          Header: "TOTAL CLAIM",
          accessor: "TOTAL_CLAIM",
          filterable: true,
          // style: "text-align: right",
          Cell: (row) => (
            <div style={{ textAlign: "right" }}>
              <span>
                {row.value !== null && row.value !== "" && row.value !== "null"
                  ? row.value.toLocaleString("en-US", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })
                  : ""}
              </span>
            </div>
          ),
        },

        {
          Header: "PARTICIPANT TYPE",
          accessor: "PARTICIPANT_TYPE",
          filterable: true,
        },
        {
          Header: "CUSTOMER",
          accessor: "CUSTOMER",
          filterable: true,
        },
        {
          Header: "STATUS APPROVAL",
          accessor: "status_approval",
          filterable: true,
        },
        {
          Header: "STATUS ACTIVE",
          accessor: "status_active",
          filterable: true,
        },
      ],
      rows: this.state.dataTable,
    };
    return (
      <ReactTable
        className="fullWidth"
        data={data.rows}
        columns={data.columns}
        defaultPageSize={10}
        defaultFilterMethod={(filter, row, column) => {
          let columnes = row[filter.id];
          return columnes
            ? columnes.toLowerCase().includes(filter.value.toLowerCase())
            : "";
        }}
      />
    );
  };

  handleExportOld = () => {
    const dataSet2 = this.state.dataTable;
    let filename =
      "program-report-" + moment(new Date()).format("DDMMYYYYHHmmss");
    console.log("OK");

    return (
      <ExcelFile
        filename={filename}
        fileExtension="xlsx"
        element={
          <button className="btn btn-success btn-block">
            <i className="fas fa-file-excel" /> Export To Excel
          </button>
        }
      >
        <ExcelSheet data={dataSet2} name="Leaves">
          <ExcelColumn label="Program No" value="program_number" />
          <ExcelColumn label="Ref No" value="ref_number" />
          <ExcelColumn label="Cabang" value="cabang" />
          <ExcelColumn label="Program Type" value="program_name" />
          <ExcelColumn label="Description" value="description" />
          <ExcelColumn label="Principal" value="org_initial" />
          <ExcelColumn label="Start Date" value="formatted_start_date" />
          <ExcelColumn label="End Date" value="formatted_end_date" />
          <ExcelColumn label="Submitted Date" value="formatted_creation_date" />
          <ExcelColumn
            label="Claim Exp Date"
            value="formatted_claim_exp_date"
          />
          <ExcelColumn label="Participant" value="member_name" />
          <ExcelColumn label="Traces No" value="skp_number" />
          <ExcelColumn label="Customer Group" value="customer_group" />
          <ExcelColumn label="Customer Name" value="customer_name" />
          <ExcelColumn label="Assign Budget" value="assign_budget" />
          <ExcelColumn label="Total Budget" value="budget" />
          <ExcelColumn label="Program Status" value="status_program" />
          <ExcelColumn label="Actual Claim Submit" value="actual_claim" />
          <ExcelColumn label="Saldo Budget" value="budget_remaining" />
        </ExcelSheet>
      </ExcelFile>
    );
  };

  handleSearch = () => {
    let url = "/api/traces/v1/report/list-program-v2";
    // let branchGroup = this.state.user.branch.map((item, index) => {
    //   return item.org_id;
    // });
    // let principalid = this.state.user.map((item, index) => {
    //   return item.org_id;
    // });

    // this.state.setPrincipal = this.state.user.org_id;
    let param = {
      export: this.state.export,
      //   org_id: this.state.setBranch,
      status: this.state.status,
      principal: "'" + this.state.user.org_id + "'",
      //   principal: principalid,
      active_status: this.state.activeStatus,
      source: "infostep",
      from_date:
        this.state.fromDate != ""
          ? moment(new Date(this.state.fromDate)).format("YYYY-MM-DD")
          : "",
      to_date:
        this.state.toDate != ""
          ? moment(new Date(this.state.toDate)).format("YYYY-MM-DD")
          : "",
      submit_from:
        this.state.submittedDateFrom != ""
          ? moment(new Date(this.state.submittedDateFrom)).format("YYYY-MM-DD")
          : "",
      submit_to:
        this.state.submittedDateTo != ""
          ? moment(new Date(this.state.submittedDateTo)).format("YYYY-MM-DD")
          : "",
    };

    console.log(param);
    this.setState({ loading: true, search: "" });
    requester.postTraces(url, param, {
      success: function (response) {
        let { data } = response.data;
        data.data.map((item, index) => {
          item.formatted_start_date = moment(new Date(item.start_date)).format(
            "DD-MM-YYYY"
          );
          item.formatted_end_date = moment(new Date(item.end_date)).format(
            "DD-MM-YYYY"
          );
          item.formatted_creation_date = moment(
            new Date(item.submitted_date)
          ).format("DD-MM-YYYY");
          item.formatted_claim_exp_date = moment(
            new Date(item.claim_exp_date)
          ).format("DD-MM-YYYY");
          return item;
        });
        if (this.state.export == true) {
          window.open(data.fullurl, "_blank");
        }

        this.setState({
          loading: false,
          dataTable: data.data,
          baseTable: data.data,
          export: false,
        });
        console.log("Called");
      }.bind(this),
      error: function (e) {
        this.setState({ loading: false });
      }.bind(this),
    });
    // this.getPrincipal();
  };

  getPrincipal = () => {
    let url = "/api/traces/v1/general/list-principal";
    requester.getTraces(url, {
      success: function (response) {
        this.setState({ lovPrincipal: response.data.data });
      }.bind(this),
      error: function (e) {
        console.log(e);
      },
    });
  };

  handleChangePrincipal = (e) => {
    this.state.setPrincipal = e.target.value;
  };
  getBranch = () => {
    // let branchGroup = this.state.user.branch.map((item, index) => {
    //     return item.org_id
    // })

    let url = "/api/traces/v1/general/list-cabang";
    requester.getTraces(url, {
      success: function (response) {
        this.setState({ lovBranch: response.data.data });
      }.bind(this),
      error: function (e) {
        console.log(e);
      },
    });

    if (this.state.user.origin === "CAB") {
      this.state.originOrgid = this.state.user.org_id;
      this.state.setBranch = this.state.user.org_id;
    }

    // this.setState({ lovBranch: this.state.user.branch });
    console.log(this.state.originOrgid);
  };

  badgeClass = (status) => {
    let className = "";
    if (status === "P") {
      className = "badge badge-info";
    } else if (status === "A") {
      className = "badge badge-success";
    } else if (status === "R") {
      className = "badge badge-danger";
    } else if (status === "S") {
      className = "badge badge-secondary";
    }
    console.log(className);
    return className;
  };

  mappingStatus = (status) => {
    let mappingStatus = "";
    if (status === "P") {
      mappingStatus = "PROPOSE";
    } else if (status === "A") {
      mappingStatus = "APPROVED";
    } else if (status === "R") {
      mappingStatus = "REJECT";
    } else if (status === "S") {
      mappingStatus = "ASSIGN";
    }
    console.log(mappingStatus);
    return mappingStatus;
  };

  handlefromDate = (date) => {
    this.setState({ fromDate: date });
  };

  handletoDate = (date) => {
    this.setState({ toDate: date });
  };

  handleSubmittedDateFrom = (date) => {
    this.setState({ submittedDateFrom: date });
  };

  handleSubmittedDateTo = (date) => {
    this.setState({ submittedDateTo: date });
  };

  handleChangeStatus = (e) => {
    this.setState({ status: e.target.value });
  };

  handleChangeStatusActive = (e) => {
    this.setState({ activeStatus: e.target.value });
  };

  handleChangeBranch = (e) => {
    this.state.setBranch = e.target.value;
  };

  handleExport = () => {
    const fileName = `report-program-${new Date().getTime()}.xlsx`
    const maping = this.state.dataTable && this.state.dataTable.length ? this.state.dataTable.map((value) => {
      return {
        "PROGRAM NO": value.PROGRAM_NO,
        "REFF NO": value.REFF_NO,
        "PROGRAM TYPE": value.PROGRAM_TYPE,
        "PRINCIPAL": value.PRINCIPAL,
        "DESCRIPTION": value.DESCRIPTION,
        "SUBMITTED DATE": value.SUBMITTED_DATE && value.SUBMITTED_DATE !== "0000-00-00" ? new Date(moment(value.SUBMITTED_DATE).utc().format("DD MMM YYYY")) : '-',
        "START DATE": value.START_DATE && value.START_DATE !== "0000-00-00" ? new Date(moment(value.START_DATE).utc().format("DD MMM YYYY")) : '-',
        "END DATE": value.END_DATE && value.END_DATE !== "0000-00-00" ? new Date(moment(value.END_DATE).utc().format("DD MMM YYYY")) : '-',
        "CLAIM EXP DATE": value.CLAIM_EXP_DATE && value.CLAIM_EXP_DATE !== "0000-00-00" ? new Date(moment(value.CLAIM_EXP_DATE).utc().format("DD MMM YYYY")) : '-',
        "BUDGET": value.BUDGET,
        "AMT CLAIM SUBMIT": value.AMT_CLAIM_SUBMIT,
        "AMT CLAIM APPROVED": value.AMT_CLAIM_APPROVED,
        "TOTAL CLAIM": value.TOTAL_CLAIM,
        "PARTICIPANT TYPE": value.PARTICIPANT_TYPE,
        "CUSTOMER": value.CUSTOMER,
        "BUDGET TYPE": value.BUDGET_TYPE,
        "status active": value.status_active,
        "status approval": value.status_approval,
      }
    }) : []

    requester.downloadXlsxDateFormat(maping, fileName)
    // this.setState({ export: true });
    // let app = this;
    // window.setTimeout(() => {
    //   app.handleSearch();
    // }, 300);
  };

  render() {
    return (
      <div>
        <section className="content">
          <div className="container-fluid">
            <div className="row ml-1">
              <div className="col-lg-12">
                <div className="card card-info">
                  <div className="card-header">List</div>
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="card">
                          <div className="card-body">
                            <div className="row mt-3">
                              {/* <div className="col-md-2">Branch</div>
                              <div className="col-md-3">
                                <select
                                  className="form-control"
                                  name="branchId"
                                  onChange={this.handleChangeBranch.bind(this)}
                                >
                                  <option value="">ALL</option>
                                  {this.state.lovBranch.map((item, index) => (
                                    <option
                                      value={item.org_id}
                                      key={index}
                                      selected={
                                        this.state.originOrgid == item.org_id
                                          ? true
                                          : false
                                      }
                                    >
                                      {item.org_name}
                                    </option>
                                  ))}
                                </select>
                              </div> */}
                              {/* <div className="col-md-2">Principal</div>
                              <div className="col-md-3">
                                <select
                                  className="form-control"
                                  name="org_id"
                                  onChange={this.handleChangePrincipal.bind(
                                    this
                                  )}
                                >
                                  <option value="">ALL</option>
                                  {this.state.lovPrincipal.map(
                                    (item, index) => (
                                      <option value={item.org_id}>
                                        {item.org_name}
                                      </option>
                                    )
                                  )}
                                </select>
                              </div> */}
                            </div>

                            <div className="clearfix">&nbsp;</div>
                            <div className="row">
                              <div className="col-md-2 mt-1">
                                Submitted Date From:{" "}
                              </div>
                              <div className="col-lg-3">
                                <DatePicker
                                  placeholder="Submitted Date from"
                                  selected={this.state.submittedDateFrom}
                                  dateFormat="d-MMM-yyyy"
                                  className="form-control myDatePicker"
                                  popperPlacement="bottom-end"
                                  onChange={this.handleSubmittedDateFrom}
                                />
                              </div>
                              <div className="col-md-2 mt-1">
                                Submitted Date To:{" "}
                              </div>
                              <div className="col-lg-3">
                                <DatePicker
                                  placeholder="Submitted Date from"
                                  selected={this.state.submittedDateTo}
                                  dateFormat="d-MMM-yyyy"
                                  className="form-control"
                                  popperPlacement="bottom-end"
                                  onChange={this.handleSubmittedDateTo}
                                />
                              </div>
                            </div>
                            <div className="row mt-3">
                              <div className="col-md-2 mt-1">
                                Period Date From:{" "}
                              </div>
                              <div className="col-lg-3">
                                <DatePicker
                                  placeholder="Submitted Date from"
                                  selected={this.state.fromDate}
                                  dateFormat="d-MMM-yyyy"
                                  className="form-control"
                                  popperPlacement="bottom-end"
                                  onChange={this.handlefromDate}
                                />
                              </div>
                              <div className="col-md-2 mt-1">
                                Period Date To:{" "}
                              </div>
                              <div className="col-lg-3">
                                <DatePicker
                                  placeholder="Submitted Date from"
                                  selected={this.state.toDate}
                                  dateFormat="d-MMM-yyyy"
                                  className="form-control"
                                  popperPlacement="bottom-end"
                                  onChange={this.handletoDate}
                                />
                              </div>
                            </div>
                            <div className="row mt-3">
                              <div className="col-md-2">Program Status</div>
                              <div className="col-md-3">
                                <select
                                  className="form-control"
                                  onChange={this.handleChangeStatus.bind(this)}
                                >
                                  <option value="">ALL</option>
                                  <option value="propose">Propose</option>
                                  <option value="app_princ">
                                    Approved by Principal
                                  </option>
                                  <option value="val">Validated</option>
                                  <option value="app_aam">
                                    Approved by AAM
                                  </option>
                                  <option value="rej_aam">
                                    Rejected by AAM
                                  </option>
                                  <option value="rej_princ">
                                    Rejected by Principal
                                  </option>
                                </select>
                              </div>
                              <div className="col-md-2">Active Status</div>
                              <div className="col-md-3">
                                <select
                                  className="form-control"
                                  onChange={this.handleChangeStatusActive.bind(
                                    this
                                  )}
                                >
                                  <option value="">All</option>
                                  <option value="Y">Active</option>
                                  <option value="N">Inactive</option>
                                </select>
                              </div>
                            </div>

                            <div className="row mt-3">
                              <div className="col-md-3">
                                <button
                                  className="btn btn-primary btn-block"
                                  onClick={this.handleSearch.bind(this)}
                                >
                                  <i class="fas fa-search"></i> Search
                                </button>
                              </div>
                              <div className="col-md-3">
                                {/* { this.handleExport() } */}
                                <button
                                  className="btn btn-success btn-block"
                                  onClick={this.handleExport.bind(this)}
                                >
                                  <i className="fas fa-file-excel" /> Export To
                                  Excel
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="clearfix">&nbsp;</div>
                    <div className="row">
                      <div className="col-lg-12">{this.renderTable()}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Loader fullPage loading={this.state.loading} />
        </section>
      </div>
    );
  }
}

export default Summary;
